export function refusalEdit(pic) {
	return {
    type: 'REFUSAL_EDIT',
		payload: {
			pic: pic,
		},
	}
};
